import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Dashboard/Sidebar/Sidebar';
import './DashboardPage.css';

const DashboardPage = () => {
  const [isOpen, setIsOpen] = useState(window.innerWidth > 768);
  const [darkMode, setDarkMode] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle('dark-theme');
  };

  const closeOnMobile = () => {
    if (window.innerWidth <= 768) setIsOpen(false);
  };

  return (
    <div className="dashboard-page">
      <Sidebar
        isOpen={isOpen}
        toggleSidebar={toggleSidebar}
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
      />
      {isOpen && <div className="sidebar-overlay" onClick={closeOnMobile}></div>}
      <div className={`dashboard-content ${isOpen ? 'shifted' : 'full'}`}>
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardPage;